import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import {
//     MuiPickersUtilsProvider,
//     DatePicker
// } from "@mui/material/pickers";
// import Tooltip from "@mui/material/Tooltip";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import BackButton from "../../components/BackButton/BackButton";
import "../../components/LoadingSpinner/spinner.css";
import { getAccountId } from "../../redux/actions/getAccountIdAction";
import { getChargeMasterList } from "../../redux/actions/getChargeMasterListAction";
import { getChargeName } from "../../redux/actions/getChargeNameAction";
import { addChargeMaster } from "../../redux/actions/addChargeMasterAction";
import { editChargeMaster } from "../../redux/actions/editChargeMasterAction";
import { getGatewayAccount } from "../../redux/actions/getGatewayAccountListAction";
import { gatewayHistory } from "../../redux/actions/gatewayHistoryAction";
import { updateGatewayAccount } from "../../redux/actions/upadateGatewayAccountAction";
import { addGatewayAccount } from "../../redux/actions/addGatewayAccountAction";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactToExcel from "react-html-table-to-excel";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";

import {
    getKycApproveRejects,
    resetGetKycApproveReject
} from "../../redux/actions/getKycApproveRejectAction";
import authTokenReducer from "../../redux/reducers/authTokenReducer";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

function AddEditChargeMaster() {
    var date = new Date();
    const [selectedDate, setSelectedDate] = useState(
        new Date(date.getFullYear(), date.getMonth(), 1)
    );

    const [selectedToDate, setSelectedToDate] = useState(new Date());

    const navigate = useHistory();
    const [addNotification, setAddNotification] = useState(false);
    const [editNotification, setEditNotification] = useState(false);
    const [notificationOpen, setNotificationOpen] = React.useState(false);
    const [page, setPage] = useState(0);

    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(true);
    const [addOpen, setAddOpen] = useState(false);
    const [editOpen, setEditOpen] = React.useState(false);
    const [viewOpen, setViewOpen] = React.useState(false);
    const [gatewayHistoryView, setGatewayHistoryView] = useState(false);
    const [type, setType] = useState();
    const [mappingId, setMappingId] = useState("");

    const [getAccountIdStatus, setGetAccountIdStatus] = useState(false);
    const [getAccountIdArray, setGetAccountIdArray] = useState("");

    const [getChargeNameStatus, setGetChargeNameStatus] = useState(false);
    const [getChargeNameArray, setGetChargeNameArray] = useState("");

    const [getChargeMasterStatus, setGetChargeMasterStatus] = useState(false);
    const [getChargeMasterArray, setGetChargeMasterArray] = useState("");

    const [addChargeMasterStatus, setAddChargeMasterStatus] = useState(false)
    const [addChargeMasterArray, setAddChargeMasterArray] = useState("")

    const [editChargeMasterStatus, setEditChargeMasterStatus] = useState(false)
    const [editChargeMasterArray, setEditChargeMasterArray] = useState("")

    const [getGatewayAccountStatus, setGetGatewayAccountStatus] = useState(false);
    const [getGatewayAccountArray, setGetGatewayAccountArray] = useState("");

    const [getGatewayHistoryStatus, setGetGatewayHistoryStatus] = useState(false);
    const [getGatewayHistoryArray, setGetGatewayHistoryArray] = useState("");

    const [addGatewayAccountStatus, setAddGatewayAccountStatus] = useState(false);
    const [addGatewayAccountArray, setAddGatewayAccountArray] = useState("");

    const [updateGatewayAccountStatus, setUpdateGatewayAccountStatus] =
        useState(false);
    const [updateGatewayAccountArray, setUpdateGatewayAccountArray] =
        useState("");

    const [modifyMerchantStatus, setModifyMerchantStatus] = useState(false);
    const [modifyMerchantArray, setModifyMerchantArray] = useState("");

    const [searchChargeName, setsearchChargeName] = useState('');

    // const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    const classes = useStyles();
    const dispatch = useDispatch();

    const [mappindIdMod, setMappingIdMod] = useState("");

    const [modifyGatewayInp, setModifyGatewayInp] = useState({
        accountId: "",
        chargeValue: "",
        DynamicInput: "",

        chargeId: "",
        chargeName: "",
        dynamicInput: "",
        chargeTechName: "",
        chargeUnit: "",
        category: "",
        keyword: "",
        subkeyword: "",
        frequency: "",
        sequenceNum: ""
    });

    const { accountId, chargeValue, DynamicInput,

        chargeId,
        chargeName,
        dynamicInput,
        chargeTechName,
        chargeUnit,
        category,
        keyword,
        subkeyword,
        frequency,
        sequenceNum
    } =
        modifyGatewayInp;

    const onInputChangeMod = ({ target: { name, value } }, type) => {
        const obj = {
            ...modifyGatewayInp
        };

        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else {
            obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
        }
        setModifyGatewayInp(obj);
    };

    const [user, setUser] = useState({
        accountIdSearch: "",
        chargeNameSearch: ""
    });

    const { accountIdSearch, chargeNameSearch } = user;

    const onInputChange = ({ target: { name, value } }, type) => {
        const obj = {
            ...user
        };

        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else {
            obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
        }
        setUser(obj);
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleToDateChange = (date) => {
        setSelectedToDate(date);
    };

    const getAccountIdRes = useSelector(({ getAccountId }) => getAccountId);

    const getChargeNameRes = useSelector(({ getChargeName }) => getChargeName);

    const getChargeMasterListRes = useSelector(({ getChargeMasterList }) => getChargeMasterList);

    const addChargeMasterRes = useSelector(({ addChargeMaster }) => addChargeMaster);

    const editChargeMasterRes = useSelector(({ editChargeMaster }) => editChargeMaster);

    const getGatewayAccountListRes = useSelector(
        ({ getGatewayAccountList }) => getGatewayAccountList
    );

    const gatewayHistoryRes = useSelector(({ gatewayHistory }) => gatewayHistory);

    const updateGatewayAccountRes = useSelector(
        ({ updateGatewayAccount }) => updateGatewayAccount
    );

    const addGatewayAccountRes = useSelector(
        ({ addGatewayAccount }) => addGatewayAccount
    );

    const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

    const adminCurrencyList = useSelector(
        ({ adminCurrencyList }) => adminCurrencyList
    );

    const getAccountIdReq = () => {
        setGetAccountIdStatus(true);
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId
            }
        };
        dispatch(getAccountId(req, authToken));
    };

    const getAccountIdFunc = () => {
        if (getAccountIdStatus) {
            if (getAccountIdRes.data.status == "success") {
                setGetAccountIdArray(getAccountIdRes.data.checkedIdList);
                setIsLoading(false);
            }
            if (getAccountIdRes.data.status == "failed") {
                setGetAccountIdArray(getAccountIdRes.data);
                setIsLoading(false);
                if (
                    getAccountIdRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getAccountIdRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getAccountIdFunc();
    }, [getAccountIdRes.data.status]);

    const getChargeNameReq = () => {
        setGetChargeNameStatus(true);
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId
            }
        };
        dispatch(getChargeName(req, authToken));
    };

    const getChargeNameFunc = () => {
        if (getChargeNameStatus) {
            if (getChargeNameRes.data.status == "success") {
                setGetChargeNameArray(getChargeNameRes.data.chargeList);
                setIsLoading(false);
            }
            if (getChargeNameRes.data.status == "failed") {
                setGetChargeNameArray(getChargeNameRes.data);
                setIsLoading(false);
                if (
                    getChargeNameRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getChargeNameRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getChargeNameFunc();
    }, [getChargeNameRes.data.status]);

    const getChargeMasterListReq = () => {
        setGetChargeMasterStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                chargeId1: searchChargeName === '' ? '' : (searchChargeName === 'Select Charge Name' ? '' : searchChargeName.split("-")[0]),
                chargeName: searchChargeName === '' ? '' : (searchChargeName === 'Select Charge Name' ? '' : searchChargeName.split("-")[1])
            }
        }
        dispatch(getChargeMasterList(req, authToken))
    }

    const getChargeMasterListFunc = () => {
        if (getChargeMasterStatus) {
            if (getChargeMasterListRes.data.status == "success") {
                setGetChargeMasterArray(getChargeMasterListRes.data.chargeList);
                setIsLoading(false);
            }
            if (getChargeMasterListRes.data.status == "failed") {
                setGetChargeMasterArray(getChargeMasterListRes.data);
                setIsLoading(false);
                if (
                    getChargeMasterListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getChargeMasterListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getChargeMasterListFunc();
    }, [getChargeMasterListRes.data.status]);

    useEffect(() => {
        console.log(chargeNameSearch, "/////////////////////////////")
    }, [chargeNameSearch])

    const addChargeMasterReq = () => {
        setAddChargeMasterStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                category: category,
                chargeName: chargeName,
                frequency: frequency,
                inputRequired: dynamicInput,
                keyName: chargeTechName,
                keyword: keyword,
                sequenceNumber: sequenceNum,
                subKey: subkeyword,
                valuetype: chargeUnit
            }
        }
        dispatch(addChargeMaster(req, authToken))
        setAddOpen(false)
    }

    const addChargeMasterFunc = () => {
        if (addChargeMasterStatus) {
            if (addChargeMasterRes.data.status == "success") {
                setAddChargeMasterArray(addChargeMasterRes.data);
                setAddNotification(true)
                getChargeMasterListReq()
            }
            if (addChargeMasterRes.data.status == "failed") {
                setAddChargeMasterArray(addChargeMasterRes.data);
                setAddNotification(true)
                if (
                    addChargeMasterRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addChargeMasterRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        addChargeMasterFunc();
    }, [addChargeMasterRes.data.status]);

    const editChargeMasterReq = () => {
        setEditChargeMasterStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                category: category,
                chargeId: chargeId,
                chargeName: chargeName,
                frequency: frequency,
                inputRequired: dynamicInput,
                keyName: chargeTechName,
                keyword: keyword,
                sequenceNumber: sequenceNum,
                subKey: subkeyword,
                valuetype: chargeUnit
            }
        }
        dispatch(editChargeMaster(req, authToken))
        setEditOpen(false)
    }

    const editChargeMasterFunc = () => {
        if (editChargeMasterStatus) {
            if (editChargeMasterRes.data.status == "success") {
                setEditChargeMasterArray(editChargeMasterRes.data);
                setEditNotification(true)
                getChargeMasterListReq()
            }
            if (editChargeMasterRes.data.status == "failed") {
                setEditChargeMasterArray(editChargeMasterRes.data);
                setEditNotification(true)
                if (
                    editChargeMasterRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    editChargeMasterRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        editChargeMasterFunc();
    }, [editChargeMasterRes.data.status]);


    const getGatewayAccountReq = () => {
        setGetGatewayAccountStatus(true);
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                accountId:
                    accountIdSearch == "Select Account ID" ? "" : accountIdSearch,
                chargeId:
                    chargeNameSearch == "Select Charge Name" ? "" : chargeNameSearch
            }
        };
        dispatch(getGatewayAccount(req, authToken));
    };

    const getGatewayAccountFunc = () => {
        if (getGatewayAccountStatus) {
            if (getGatewayAccountListRes.data.status == "success") {
                setGetGatewayAccountArray(
                    [].concat(getGatewayAccountListRes.data.chargeList)
                );
                setIsLoading(false);
            }
            if (getGatewayAccountListRes.data.status == "failed") {
                setGetGatewayAccountArray(getGatewayAccountListRes.data);
                setIsLoading(false);
                if (
                    getGatewayAccountListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getGatewayAccountListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getGatewayAccountFunc();
    }, [getGatewayAccountListRes.data.status]);

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getChargeNameReq();
            getChargeMasterListReq()
            getGatewayAccountReq();
        }
    }, [regenerateTokenRes.data.status]);

    const gatewayHistoryReq = (mappingId, type) => {
        console.log(mappingId, type, ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
        setGetGatewayHistoryStatus(true);
        setType(type);
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                mappindId: mappingId
            }
        };
        dispatch(gatewayHistory(req, authToken));
        setMappingId(mappingId);
        if (type == "modify") {
            setEditOpen(true);
        }
        if (type == "history") {
            setGatewayHistoryView(true);
        }
    };

    const getGatewayHistoryFunc = () => {
        if (getGatewayHistoryStatus) {
            if (gatewayHistoryRes.data.status == "success") {
                setGetGatewayHistoryArray(gatewayHistoryRes.data.chargeList);
            }
            if (gatewayHistoryRes.data.status == "failed") {
                setGetGatewayHistoryArray(gatewayHistoryRes.data);
                if (
                    gatewayHistoryRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    gatewayHistoryRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getGatewayHistoryFunc();
    }, [gatewayHistoryRes.data.status]);

    useEffect(() => {
        if (gatewayHistoryRes.data.status == "success") {
            if (type == "modify") {
                setModifyGatewayInp({
                    accountId: getGatewayHistoryArray.accountId,
                    DynamicInput: getGatewayHistoryArray.isInputRequired,
                    chargeValue: getGatewayHistoryArray.chargevalue,
                    sequenceNum: getGatewayHistoryArray.sequencenum
                });
                if (
                    getGatewayHistoryArray.startdate &&
                    getGatewayHistoryArray.enddate
                ) {
                    setSelectedDate(getGatewayHistoryArray.startdate.split(" ")[0]);
                    setSelectedToDate(getGatewayHistoryArray.enddate.split(" ")[0]);
                }
            }
        }
    }, [getGatewayHistoryArray]);

    const updateGatewayAccountReq = () => {
        setUpdateGatewayAccountStatus(true);
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                chargeValue: chargeValue,
                fdtstamp: moment(selectedDate).format("YYYY/MM/DD"),
                tdtstamp: moment(selectedToDate).format("YYYY/MM/DD"),
                mappingId: mappingId
            }
        };
        dispatch(updateGatewayAccount(req, authToken));
        setEditOpen(false);
    };

    const updateGatewayAccountFunc = () => {
        if (updateGatewayAccountStatus) {
            if (updateGatewayAccountRes.data.status == "success") {
                setUpdateGatewayAccountArray(updateGatewayAccountRes.data);
                setIsLoading(false);
                setEditNotification(true);
                getGatewayAccountReq();
            }
            if (updateGatewayAccountRes.data.status == "failed") {
                setUpdateGatewayAccountArray(updateGatewayAccountRes.data);
                setIsLoading(false);
                setEditNotification(true);
                if (
                    updateGatewayAccountRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    updateGatewayAccountRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        updateGatewayAccountFunc();
    }, [updateGatewayAccountRes.data.status]);

    const addGatewayAccountReq = () => {
        setAddGatewayAccountStatus(true);
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                accountId: accountId,
                inputRequired: DynamicInput,
                chargeValue: chargeValue,
                chargeId: chargeName,
                sequenceNumber: sequenceNum,
                fdtstamp: moment(selectedDate).format("YYYY/MM/DD"),
                tdtstamp: moment(selectedToDate).format("YYYY/MM/DD")
            }
        };
        dispatch(addGatewayAccount(req, authToken));
        setAddOpen(false);
    };

    const addGatewayAccountFunc = () => {
        if (addGatewayAccountStatus) {
            if (addGatewayAccountRes.data.status == "success") {
                setAddGatewayAccountArray(addGatewayAccountRes.data);
                setIsLoading(false);
                setAddNotification(true);
                getGatewayAccountReq();
            }
            if (addGatewayAccountRes.data.status == "failed") {
                setAddGatewayAccountArray(addGatewayAccountRes.data);
                setIsLoading(false);
                setAddNotification(true);
                if (
                    addGatewayAccountRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addGatewayAccountRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        addGatewayAccountFunc();
    }, [addGatewayAccountRes.data.status]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleClose = () => {
        setEditOpen(false);
        setAddOpen(false);
        setViewOpen(false);
        setGatewayHistoryView(false);
        setModifyGatewayInp({
            accountId: "",
            chargeValue: "",
            DynamicInput: "",
            sequenceNum: ""
        });
        setMappingIdMod("");
        setSelectedDate(new Date(date.getFullYear(), date.getMonth(), 1));
        setSelectedToDate(new Date());
    };

    const openAdd = () => {
        setAddOpen(true);
    };

    const openEdit = (row) => {
        setEditOpen(true);
        setModifyGatewayInp({
            accountId: "",
            chargeValue: "",
            DynamicInput: "",
            sequenceNum: "",

            chargeId: row.chargeid,
            chargeName: row.chargename,
            dynamicInput: row.isinputrequired,
            chargeTechName: row.keyName,
            chargeUnit: row.valuetype,
            category: row.category,
            keyword: row.keyword,
            subkeyword: row.subkeyword,
            frequency: row.frequency,
            sequenceNum: row.sequencenum
        });
    };

    const handleNoticationClose = () => {
        setNotificationOpen(false);
        setEditNotification(setEditNotification(true));
        setAddNotification(false);
    };

    const changedInputFunc = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'chargeNameSearch') {
            setsearchChargeName(value)
        }
    }

    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px",
                            textAlign: "center"
                        }}
                    >
                        <Grid item xs={12} md={8} sm={3} lg={8}></Grid>
                        <Grid item xs={12} md={4} sm={3} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={() => openAdd()}
                            >
                                Add New Charge
                            </CustomButton>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Charge Name"
                               
                                fullWidth={true}
                                name="chargeNameSearch"
                                defaultValue={chargeNameSearch || "Select Charge Name"}
                                onChange={changedInputFunc}
                            >
                                <MenuItem
                                    value="Select Charge Name"
                                    selected="Select Charge Name"
                                >
                                    Select Charge Name
                                </MenuItem>
                                {getChargeNameRes.success &&
                                    getChargeNameRes.data.chargeList.map((x) => (
                                        <MenuItem value={`${x.chargeid}-${x.chargename}`}>
                                            {x.chargename + " - " + x.valuetype}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={getChargeMasterListReq}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : getChargeMasterArray == undefined || getChargeMasterArray.length == 0 || getChargeMasterArray == [] || !getChargeMasterArray ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}>
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Charge Name{" "}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Is Input Required
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Key Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Charge Unit
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Category
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Keyword
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Sub-Keyword
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Frequency
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Sequence No
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {getChargeMasterArray &&
                                                []
                                                    .concat(getChargeMasterArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.chargename}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.isinputrequired}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.keyName}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.valuetype}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.category}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.keyword}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.subkeyword}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.frequency}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.sequencenum}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() =>
                                                                        openEdit(row)
                                                                    }
                                                                >
                                                                    Modify
                                                                </CustomButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(getChargeMasterArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    </div>
                )}
            </Layout>

            <div>
                <Dialog open={addOpen} onClose={handleClose}>
                    <DialogTitle>Add New Charge</DialogTitle>
                    <DialogContent>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                             variant="standard"
                            type="text"
                            label="Charge Name"
                            fullWidth={true}
                            name="chargeName"
                            value={chargeName || ""}
                            onChange={(e) => onInputChangeMod(e, "alphabet")}
                        >
                        </TextField>
                        <TextField
                            select
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                             variant="standard"
                            label="Dynamic Input"
                            fullWidth={true}
                            name="dynamicInput"
                            value={dynamicInput || "Select Dynamic Input"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem
                                value="Select Dynamic Input"
                            >
                                Select Dynamic Input
                            </MenuItem>
                            <MenuItem
                                value="Y"
                            >
                                Y
                            </MenuItem>
                            <MenuItem
                                value="N"
                            >
                                N
                            </MenuItem>
                        </TextField>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                             variant="standard"
                            label="Charge Technical Name"
                            fullWidth={true}
                            name="chargeTechName"
                            value={chargeTechName || ""}
                            onChange={(e) => onInputChangeMod(e, "alphabet")}
                        ></TextField>
                        <TextField
                            select
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                             variant="standard"
                            type="text"
                            label="Charge Unit"
                            fullWidth={true}
                            name="chargeUnit"
                            value={chargeUnit || "Select Charge Unit"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem
                                value="Select Charge Unit"
                                selected="Select Charge Unit"
                            >
                                Select Charge Unit
                            </MenuItem>
                            <MenuItem value="FlatRate">FlatRate</MenuItem>
                            <MenuItem value="Percentage">Percentage</MenuItem>
                        </TextField>
                        <TextField
                            select
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                             variant="standard"
                            type="text"
                            label="Category"
                            fullWidth={true}
                            name="category"
                            value={category || "Select Category"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem
                                value="Select Category"
                                selected="Select Category"
                            >
                                Select Category
                            </MenuItem>
                            <MenuItem value="Success">Success</MenuItem>
                            <MenuItem value="Failure">Failure</MenuItem>
                            <MenuItem value="Others">Others</MenuItem>
                        </TextField>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                             variant="standard"
                            type="text"
                            label="Keyword"
                            fullWidth={true}
                            name="keyword"
                            value={keyword || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        ></TextField>
                        <TextField
                            select
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                             variant="standard"
                            type="text"
                            label="Sub Keyword"
                            fullWidth={true}
                            name="subkeyword"
                            value={subkeyword || "Select Sub Keyword"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem
                                value="Select Sub Keyword"
                                selected="Select Sub Keyword"
                            >
                                Select Sub Keyword
                            </MenuItem>
                            <MenuItem value="Amount">Amount</MenuItem>
                            <MenuItem value="Count">Count</MenuItem>
                        </TextField>
                        <TextField
                            select
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                             variant="standard"
                            color="primary"
                            type="text"
                            label="Frequency"
                            fullWidth={true}
                            name="frequency"
                            value={frequency || "Select Frequency"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem
                                value="Select Frequency"
                                selected="Select Frequency"
                            >
                                Select Frequency
                            </MenuItem>
                            <MenuItem value="Per_Transaction">Per Transaction</MenuItem>
                            <MenuItem value="Yearly">Yearly</MenuItem>
                            <MenuItem value="Monthly">Monthly</MenuItem>
                            <MenuItem value="Weekly">Weekly</MenuItem>
                            <MenuItem value="One_Time">One Time</MenuItem>
                        </TextField>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                             variant="standard"
                            type="text"
                            label="Sequence Number"
                            fullWidth={true}
                            name="sequenceNum"
                            value={sequenceNum || ""}
                            onChange={(e) => onInputChangeMod(e, "number")}
                        ></TextField>
                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            onClick={addChargeMasterReq}
                        >
                            Add
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={editOpen} onClose={handleClose}>
                    <DialogTitle>Modify Merchant Charge</DialogTitle>
                    <DialogContent>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            variant="standard"
                            label="Charge Name"
                            fullWidth={true}
                            name="chargeName"
                            value={chargeName || ""}
                            onChange={(e) => onInputChangeMod(e, "alphabet")}
                        >
                        </TextField>
                        <TextField
                            select
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            variant="standard"

                            label="Dynamic Input"
                            fullWidth={true}
                            name="dynamicInput"
                            value={dynamicInput || "Select Dynamic Input"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem
                                value="Select Dynamic Input"
                            >
                                Select Dynamic Input
                            </MenuItem>
                            <MenuItem
                                value="Y"
                            >
                                Y
                            </MenuItem>
                            <MenuItem
                                value="N"
                            >
                                N
                            </MenuItem>
                        </TextField>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            variant="standard"

                            type="text"
                            label="Charge Technical Name"
                            fullWidth={true}
                            name="chargeTechName"
                            value={chargeTechName || ""}
                            onChange={(e) => onInputChangeMod(e, "alphabet")}
                        ></TextField>
                        <TextField
                            select
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            variant="standard"

                            type="text"
                            label="Charge Unit"
                            fullWidth={true}
                            name="chargeUnit"
                            value={chargeUnit || "Select Charge Unit"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem
                                value="Select Charge Unit"
                                selected="Select Charge Unit"
                            >
                                Select Charge Unit
                            </MenuItem>
                            <MenuItem value="FlatRate">FlatRate</MenuItem>
                            <MenuItem value="Percentage">Percentage</MenuItem>
                        </TextField>
                        <TextField
                            select
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            variant="standard"

                            color="primary"
                            type="text"
                            label="Category"
                            fullWidth={true}
                            name="category"
                            value={category || "Select Category"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem
                                value="Select Category"
                                selected="Select Category"
                            >
                                Select Category
                            </MenuItem>
                            <MenuItem value="Success">Success</MenuItem>
                            <MenuItem value="Failure">Failure</MenuItem>
                            <MenuItem value="Others">Others</MenuItem>
                        </TextField>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            variant="standard"

                            type="text"
                            label="Keyword"
                            fullWidth={true}
                            name="keyword"
                            value={keyword || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        ></TextField>
                        <TextField
                            select
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            variant="standard"

                            type="text"
                            label="Sub Keyword"
                            fullWidth={true}
                            name="subkeyword"
                            value={subkeyword || "Select Sub Keyword"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem
                                value="Select Sub Keyword"
                                selected="Select Sub Keyword"
                            >
                                Select Sub Keyword
                            </MenuItem>
                            <MenuItem value="Amount">Amount</MenuItem>
                            <MenuItem value="Count">Count</MenuItem>
                        </TextField>
                        <TextField
                            select
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            variant="standard"

                            type="text"
                            label="Frequency"
                            fullWidth={true}
                            name="frequency"
                            value={frequency || "Select Frequency"}
                            onChange={(e) => onInputChangeMod(e)}
                        >
                            <MenuItem
                                value="Select Frequency"
                                selected="Select Frequency"
                            >
                                Select Frequency
                            </MenuItem>
                            <MenuItem value="Per_Transaction">Per Transaction</MenuItem>
                            <MenuItem value="Yearly">Yearly</MenuItem>
                            <MenuItem value="Monthly">Monthly</MenuItem>
                            <MenuItem value="Weekly">Weekly</MenuItem>
                            <MenuItem value="One_Time">One Time</MenuItem>
                        </TextField>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            variant="standard"

                            type="text"
                            label="Sequence Number"
                            fullWidth={true}
                            name="sequenceNum"
                            value={sequenceNum || ""}
                            onChange={(e) => onInputChangeMod(e, "number")}
                        ></TextField>
                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            onClick={editChargeMasterReq}
                        >
                            Update
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            {editChargeMasterArray.status == "success" && (
                <div>
                    <Dialog open={editNotification} onClose={handleNoticationClose}>
                        <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
                        
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {editChargeMasterArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {editChargeMasterArray.status == "failed" && (
                <div>
                    <Dialog open={editNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {editChargeMasterArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addChargeMasterArray.status == "success" && (
                <div>
                    <Dialog open={addNotification} onClose={handleNoticationClose}>
                        <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
                        
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addChargeMasterArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addChargeMasterArray.status == "failed" && (
                <div>
                    <Dialog open={addNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addChargeMasterArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    );
}

export default AddEditChargeMaster;
